var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading-screen',{attrs:{"is-loading":_vm.isLoading}}),_c('v-app',{staticStyle:{"background-color":"#EEEEEE"}},[_c('Navigation'),_c('v-content',[_c('router-view')],1),_c('CompFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }